export class GetEmailAddressError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "GetEmailAddressError";
  }
}
